import { useCallback, useMemo, useState } from 'react';
import { Button, DatePicker, Form, Input, InputNumber, Select, message } from 'antd';
import AgentList from '../AgentList';
import { FilterPayload, getAgentList } from 'api/agent';
import { FileExcelFilled } from '@ant-design/icons';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { handleOnlyNumber } from 'features/nach/utils/handleOnlyNumber';

const dateFormat = 'DD/MM/YYYY';
type Props = {
  isLoading: boolean;
  onSubmit: (values: FilterPayload) => Promise<void>;
};
// const SourceApplicationName = sessionStorage.getItem('source')?.toString();

let filterPayload: FilterPayload = {};

const Filter = ({ onSubmit }: Props) => {
  const { Option } = Select;

  const [form] = Form.useForm<FilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const isAdmin = sessionStorage.getItem('isAdmin');
  const [onlyDigitError, setOnlyDigitError] = useState(false);
  const handleSubmit = useCallback(
    async (values: FilterPayload) => {
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      updatedValues.PageNo = 1;
      updatedValues.PageSize = 10;
      if (isAdmin != 'true') {
        updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      }

      setFilter(updatedValues);

      // await onSubmit(values);
      //setFilter(values);
      // form.resetFields();
      // console.log('values filtering');
    },
    [onSubmit, form]
  );

  function handleDownload(_e: any) {
    const filterValues: FilterPayload = form.getFieldsValue();
    filterValues.isExtract = true;

    if (isAdmin != 'true') {
      filterValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    debugger;
    getAgentList(filterValues).then((_x) => {
      const dashboardData = _x.data.data;
      debugger;
      if (dashboardData.length <= 0) {
        message.info('No Result Extrated');
      }
      const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: 'Agent Dashboard - Report' });
      const csv = generateCsv(csvConfig)(dashboardData);
      download(csvConfig)(csv);
    });
  }

  // function handleReset(_e: any) {
  //   form.resetFields();
  //   let updatedFilter = { ...filter };
  //   updatedFilter = filterPayload;
  //   setFilter(updatedFilter);
  //   handleSubmit(filterPayload);
  // }
  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
  }
  const memoizedFilter = useMemo(() => filter, [filter]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Agent Dashboard</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<FilterPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['SourceApplicationName']: sessionStorage.getItem('source')?.toString(),
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Number :'} name="LANumber" className="fieldTitle">
                          <Input placeholder={'Loan Number'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose :'}
                          name="PaymentPurpose"
                          className="fieldTitle"
                        >
                          {/* <InputNumber placeholder={'Payment Purpose'} /> */}
                          <Select placeholder="Select" size="large">
                            <Option value="Fees">Fees</Option>
                            <Option value="Foreclosure">Foreclosure</Option>
                            <Option value="Overdue">Overdue</Option>
                            <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                            <Option value="PartPayment">PartPayment</Option>
                            <Option value="ADVANCEEMI">Advance EMI</Option>
                            <Option value="OtherCharges">Other Charges</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Request ID :'}
                          name="PaymentRequestId"
                          className="fieldTitle"
                          validateStatus={onlyDigitError ? 'error' : ''}
                          help={onlyDigitError ? 'Only numbers are allowed' : ''}
                        >
                          <InputNumber
                            value={form.getFieldValue('PaymentRequestId')}
                            onBeforeInput={(e) => handleOnlyNumber(e, setOnlyDigitError)}
                            placeholder={'Payment Request ID:'}
                          />
                        </Form.Item>
                      </div>
                    </div>{' '}
                  </div>

                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Date From:'}
                          name="fromDate"
                          className="fieldTitle"
                        >
                          <DatePicker format={dateFormat} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'To :'} name="toDate" className="fieldTitle">
                          <DatePicker format={dateFormat} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div style={{ float: 'right', marginBottom: '10px' }}>
                    <Button
                      type="link"
                      icon={<FileExcelFilled />}
                      style={{ float: 'right', fontSize: '30px', color: 'green' }}
                      onClick={handleDownload}
                    ></Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      onClick={handleReset}
                      style={{ float: 'right', marginRight: '5px' }}
                    >
                      {'CLEAR'}
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ float: 'right', marginRight: '10px' }}
                    >
                      {'SEARCH'}
                    </Button>
                  </div>
                </Form>
              </div>
              <AgentList filter={memoizedFilter} setOnlyDigitError={setOnlyDigitError} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Filter;
